import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { PopularSmartTags } from "~/components/Filters/SmartTagsFilter/PopularSmartTags";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
import { useGetPrivateSmartTagList } from "~/swr-hooks/filters/useGetPrivateSmartTagList";
export const PrivatePopularSmartTags = /*#__PURE__*/ memo((param)=>{
    let { className, onSmartTagClick } = param;
    const { currentWorkspace } = useCurrentWorkspace();
    const { data: popularSmartTags } = useGetPrivateSmartTagList({
        sortField: "count",
        sortDirection: "desc",
        limit: 10,
        workspaceId: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.id
    });
    if (!popularSmartTags) {
        return null;
    }
    return /*#__PURE__*/ _jsx(PopularSmartTags, {
        className: className,
        smartTags: popularSmartTags,
        onSmartTagClick: onSmartTagClick
    });
});
PrivatePopularSmartTags.displayName = "PrivatePopularSmartTags";
